import { customFetch } from '#/services/customFetch'
import type { Tag } from '../types/course.types'

export async function getTags(): Promise<Tag[]> {
  return customFetch<Tag[]>('/student/tags')
}
